import { FC } from "react"

import { ReactComponent as IconExport } from "@common_assets/svg/export.svg"
import { CircularProgress, Tooltip, useTheme } from "@mui/material"
import { useTranslation } from "react-i18next"
import { ExportIconWrapper } from "styles/common/box"

interface IExportButtonProps {
  isFetching: boolean
  onClick: (event: React.MouseEvent<HTMLElement>) => void
}

/**
 * Reusable ExportButton component
 * Displays an export icon with loading state
 */
const ExportButton: FC<IExportButtonProps> = ({ isFetching, onClick }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Tooltip title={t("allTransactions.export")} arrow={true} placement="top">
      <ExportIconWrapper
        role="button"
        tabIndex={0}
        aria-label={t("allTransactions.export")}
        sx={{
          minWidth: "48px",
          height: "48px",
          m: "auto",
        }}
        onClick={onClick}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault()
            onClick(event as unknown as React.MouseEvent<HTMLElement>)
          }
        }}
      >
        <span style={{ margin: "auto" }}>
          {isFetching ? (
            <CircularProgress />
          ) : (
            <IconExport
              style={{
                color: theme.palette.primary.main,
                margin: "auto",
              }}
            />
          )}
        </span>
      </ExportIconWrapper>
    </Tooltip>
  )
}

export default ExportButton
